import { render, staticRenderFns } from "./alocacao-total.vue?vue&type=template&id=65d708ea&scoped=true&"
import script from "./alocacao-total.vue?vue&type=script&lang=js&"
export * from "./alocacao-total.vue?vue&type=script&lang=js&"
import style0 from "./alocacao-total.vue?vue&type=style&index=0&id=65d708ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d708ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
